"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapViewElementTooltipPositions = exports.MapViewFilters = void 0;
var MapViewFilters;
(function (MapViewFilters) {
    MapViewFilters["ZONE_AND_PASSAGE"] = "zoneAndPassage";
    MapViewFilters["METRIC"] = "metric";
    MapViewFilters["CUSTOM"] = "custom";
})(MapViewFilters = exports.MapViewFilters || (exports.MapViewFilters = {}));
var MapViewElementTooltipPositions;
(function (MapViewElementTooltipPositions) {
    MapViewElementTooltipPositions["LEFT"] = "LEFT";
    MapViewElementTooltipPositions["RIGHT"] = "RIGHT";
    MapViewElementTooltipPositions["TOP"] = "TOP";
    MapViewElementTooltipPositions["BOTTOM"] = "BOTTOM";
    MapViewElementTooltipPositions["CENTER"] = "CENTER";
})(MapViewElementTooltipPositions = exports.MapViewElementTooltipPositions || (exports.MapViewElementTooltipPositions = {}));
